import React from 'react'
import {
  FaPlus as Plus,
  FaTrash as Trash2,
  FaChevronRight as ChevronRight,
  FaCalendarAlt as Calendar,
  FaMapMarkerAlt as MapPin,
  FaUsers as Users,
  FaAward as Award,
  FaUserPlus as UserPlus,
  FaChevronDown as ChevronDown,
  FaChevronUp as ChevronUp,
  FaMinus as Minus,
  FaTimes as X,
} from 'react-icons/fa'
const formatDate = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}
export const CompletedEvent = ({ eventData }) => (
  <div className="main_rgister_page">
    <div className="main-container">
      <div className="fixed-background">
        <div className="bg-decorations">
          <div className="decoration-circle-1"></div>
          <div className="decoration-circle-2"></div>
          <div className="decoration-circle-3"></div>
          <div className="floating-shape-1"></div>
          <div className="floating-shape-2"></div>
          <div className="floating-shape-3"></div>
          <div className="triangle-1"></div>
          <div className="triangle-2"></div>
          <div className="diamond-1"></div>
          <div className="diamond-2"></div>
          <div className="wavy-line-1">
            <svg viewBox="0 0 30 240" className="w-full h-full">
              <path
                d="M15 0 Q25 30 15 60 Q5 90 15 120 Q25 150 15 180 Q5 210 15 240"
                stroke="rgba(255, 255, 255, 0.6)"
                strokeWidth="3"
                fill="none"
                opacity="0.8"
              />
            </svg>
          </div>
          <div className="wavy-line-2">
            <svg viewBox="0 0 20 160" className="w-full h-full">
              <path
                d="M10 0 Q15 20 10 40 Q5 60 10 80 Q15 100 10 120 Q5 140 10 160"
                stroke="rgba(245, 158, 11, 0.7)"
                strokeWidth="2"
                fill="none"
                opacity="0.7"
              />
            </svg>
          </div>
          <div className="particle-1"></div>
          <div className="particle-2"></div>
          <div className="particle-3"></div>
          <div className="particle-4"></div>
          <div className="particle-5"></div>
          <div className="gradient-orb-1"></div>
          <div className="gradient-orb-2"></div>
          <div className="gradient-orb-3"></div>
          <div className="polygon-1"></div>
          <div className="polygon-2"></div>
          <div className="spiral-1"></div>
          <div className="spiral-2"></div>
          <div className="star-1"></div>
          <div className="star-2"></div>
          <div className="star-3"></div>
          <div className="plus-1"></div>
          <div className="plus-2"></div>
        </div>
      </div>

      <div className="card-container">
        <div className="main-card">
          <div className="sticky-event-header">
            <div className="sticky-event-content">
              <h1 className="sticky-event-title">
                {eventData?.event_name || 'Event'}
              </h1>
              <div className="sticky-event-details">
                <div className="sticky-event-item">
                  <Calendar className="icon-sm" />
                  <span>
                    {eventData
                      ? `${formatDate(eventData.start_date)} - ${formatDate(
                          eventData.end_date
                        )}`
                      : 'Loading...'}
                  </span>
                </div>
                <div className="sticky-event-separator"></div>
                <div className="sticky-event-item">
                  <MapPin className="icon-sm" />
                  <span>{eventData?.venue_city || 'Location'}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="card-header">
            <div className="event-banner">
              <img
                src={
                  eventData?.event_pages?.event_banner_image?.value
                    ? JSON.parse(eventData.event_pages.event_banner_image).value
                    : 'https://via.placeholder.com/1200x400'
                }
                alt="Event Banner"
                className="banner-image"
              />
              <div className="banner-overlay"></div>
            </div>
            <div className="logo-container">
              <div className="logo-wrapper">
                <div className="logo-square">
                  <img
                    src={
                      eventData?.event_logo || 'https://via.placeholder.com/150'
                    }
                    alt="Event Logo"
                    className="logo-image"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card-content">
            <div className="content-header">
              <h3 className="content-title">Event Completed</h3>
            </div>
            <div className="text-center py-8">
              <p className="text-lg mb-4">
                {eventData?.event_name || 'This event'} has concluded. Thank you
                for your interest!
              </p>
              <p className="text-gray-600">
                Check back for future events and updates.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
